import axios, { AxiosResponse, AxiosError } from "axios";

export const BROWSER_ID_STORAGE_KEY = 'browserId';

// Ensure we have a valid API URL
const apiUrl = '/api';

const httpClient = axios.create({
  baseURL: apiUrl,
});

let currentToken: string | null = null;
let currentBrowserId: string | null = null;
let isTokenInitialized = false;
const requestQueue: (() => void)[] = [];

const processRequestQueue = () => {
  while (requestQueue.length > 0) {
    const request = requestQueue.shift();
    request?.();
  }
};

// Add a global request interceptor that will always be first
httpClient.interceptors.request.use(
  (config: any) => {

    // Ensure headers object exists
    config.headers = config.headers || {};

    // If token is not initialized, queue the request
    if (!isTokenInitialized && !config.url?.includes('/auth/')) {
      return new Promise((resolve) => {
        requestQueue.push(() => resolve(config));
      });
    }

    // Always add the token if we have one
    if (currentToken) {
      config.headers.Authorization = currentToken;
    }

    if (currentBrowserId) {
      config.headers['Browser-Id'] = currentBrowserId;
    }
    return config;
  },
  (error: AxiosError) => {
    console.error('[DEBUG_LOG] Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error logging
httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 403) {
      window.location.href = '/forbidden';
      // Optionally, return a never-resolving promise to stop further error handling
      return new Promise(() => { });
    }
    return Promise.reject(error);
  }
);

export const addAuthInterceptor = (accessToken: string | null) => {

  if (!accessToken) {
    return;
  }

  // Store the token globally
  currentToken = accessToken.startsWith('Bearer ') ? accessToken : `Bearer ${accessToken}`;
  isTokenInitialized = true;
  
  // Process any queued requests
  processRequestQueue();
};

export const removeAuthInterceptor = () => {
  currentToken = null;
  isTokenInitialized = false;
  currentBrowserId = null;
};

export const setBrowserId = (browserId: string | null) => {
  currentBrowserId = browserId;
};

export default httpClient;
